<style lang="stylus" scoped>
.stepFont {
  color: white;
  font-weight: 500;
  font-size: 25px;
  display: block;
  margin-bottom: 10px;
}

.orientationFont {
  margin: 15px;
  display: flex;
  justify-content: space-between;
}

.orientationImage {
  a {
    color: white;
    font-weight: bold;
    border-bottom: 2px solid #fdc528;
  }

  p {
    font-weight: 400;
    font-size: 1.2rem;
    color: white;
  }

  .v-icon {
    backgrounded-color: #fdc528;
    margin-right: 14px;
    border-radius: 50%;
    margin-left: 82px;
    margin-bottom: -6px;

    .orientation-icon-position2 {
      font-size: 28px !important;
    }

    .orientation-icon-position1 {
      font-size: 30px;
    }
  }
}

.stepsText {
  margin-left: 25px;
}

.orientation-icon-position1 {
  border: 3px solid #FFFFFF;
  color: #000000 !important;
  font-weight: 300;
  font-size: 30px;
  padding: 8px;
}

.orientation-icon-position2 {
  border: 3px solid #FFFFFF;
  font-weight: 300;
  color: #000000 !important;
  padding: 10px 7px 8px 8px;
  font-size: 28px;
}

.orientation-icon-position3 {
  padding: 10px 7px 8px 8px;
}

.firstLine {
  position: absolute;
  height: 84%;
  border-left: 2px solid #E8E8E8;
  margin-left: 109px;
  margin-top: 30px;
}

.step-content {
  margin-left: 68px;
}

.step-content-bullet {
  margin: 8px 24px 0 85px;
  display: list-item;
}

.orientationImage i {
  position: absolute;
}

@media (max-width: 600px) {
  .firstLine {
    position: absolute;
    height: 80%;
    border-left: 2px solid #E8E8E8;
    margin-left: 33px;
    margin-top: 40px;
  }

  .orientationFont {
    margin: 0;
  }

  .orientationImage {
    margin-top: 32px;

    .v-icon {
      font-size: 18px;
      margin-left: 16px;

      .orientation-icon-position2 {
        font-size: 28px !important;
      }
    }
  }

  .orientation-icon-position1 {
    padding: 6px;
    float: none;
  }

  .orientation-icon-position2 {
    padding: 6px 4.88px;
    float: none;
  }

  .orientation-icon-position3 {
    padding: 7px 6px 5px 6px;
  }

  .stepFont {
    font-size: 18px;
    font-weight: bold;
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  .step-content {
    margin-left: 166px;
  }

  .step-content-bullet {
    margin: 8px 24px 0 182px;
  }
}
</style>
<template>
  <div>
    <v-row row wrap class="d-flex d-sm-none">
      <v-col cols="12">
        <div style="text-align: center; margin-top: 38px; margin-bottom: 28px">
          <div style class="d-flex d-sm-none">
            <span
              style="
                border-bottom: 4px solid #ffc627;
                font-size: 18px;
                font-weight: 900;
                height: 24px;
                display: inline-block;
              "
              >Here’s what happens next&#58;</span
            >
          </div>
        </div>
      </v-col>
    </v-row>
    <div class="orientationFont" v-if="!shouldLogin">
      <v-row row wrap style="backgrounded-color: #2a2a2a">
        <v-col cols="12" md="12" class="d-none d-sm-flex">
          <div style="text-align: center; margin-top: 66px; margin-bottom: 48px">
            <span style="padding: 13.5px 27.13px; backgrounded-color: white">
              <span
                style="
                  border-bottom: 4px solid #ffc627;
                  font-size: 30px;
                  font-weight: 900;
                  height: 36px;
                  display: inline-block;
                "
                >Here’s what happens next&#58;</span
              >
            </span>
          </div>
        </v-col>
        <v-col cols="12" lg="10" md="10" sm="12" style="position: relative">
          <div class="firstLine" />
          <div class="orientationImage">
            <v-icon class="orientation-icon-position1">mdi-email-open</v-icon>

            <p class="d-none d-md-flex" style="margin-left: 160px">
              <span class="stepFont">Step one</span>
              You will receive an email in the next 2-3 business days containing your ASURITE ID. This is your unique
              ASU login credential.
            </p>
            <p class="d-none d-lg-flex step-content">
              <span class="stepFont">Step one</span>
              You will receive an email in the next 2-3 business days containing your ASURITE ID. This is your unique
              ASU login credential.
            </p>
          </div>
          <div class="orientationImage" style="margin-top: 31px">
            <v-icon class="orientation-icon-position2">mdi-monitor</v-icon>

            <p class="d-none d-md-flex" style="margin-left: 160px">
              <span class="stepFont">Step two</span>
              Once you've received your ASURITE ID, follow the directions in the email to activate it.
            </p>
            <p class="d-none d-md-flex" style="margin-left: 178px; display: list-item">
              After activating your ASURITE ID, please wait 24 hours before logging in to allow ASU's systems time to
              sync your account.
            </p>
            <p class="d-none d-md-flex" style="margin-left: 178px; display: list-item">
              In the meantime, please review our
              <a
                style="color: #ffc627"
                :href="ulcPartnerFlag ? 'https://courses.ulc.asu.edu/courses/' : 'https://courses.ea.asu.edu/courses/'"
                target="_blank"
                @click="
                  asuoDataLayerClick('Orientation', '0', {
                    text: ulcPartnerFlag
                      ? 'https://courses.ulc.asu.edu/courses/'
                      : 'https://courses.ea.asu.edu/courses/'
                  })
                "
                >course catalog</a
              >.
            </p>
            <p class="d-none d-lg-flex step-content">
              <span class="stepFont">Step two</span>
              Once you've received your ASURITE ID, follow the directions in the email to activate it.
            </p>
            <p class="d-none d-lg-flex step-content-bullet">
              After activating your ASURITE ID, please wait 24 hours before logging in to allow ASU's systems time to
              sync your account.
            </p>
            <p class="d-none d-lg-flex step-content-bullet">
              In the meantime, please review our
              <a
                style="color: #ffc627"
                :href="ulcPartnerFlag ? 'https://courses.ulc.asu.edu/courses/' : 'https://courses.ea.asu.edu/courses/'"
                target="_blank"
                @click="asuoDataLayerClick('Orientation', '0')"
                >course catalog</a
              >.
            </p>
          </div>
          <div class="orientationImage" style="margin-top: 31px">
            <v-icon class="orientation-icon-position1">mdi-login</v-icon>

            <p class="d-none d-md-flex" style="margin-left: 160px">
              <span class="stepFont">Step three</span>
              Once the above steps are completed, sign into your student dashboard at
              <a
                style="color: #ffc627"
                :href="ageBasedURL.href"
                target="_blank"
                @click="asuoDataLayerClick('Orientation', '1')"
              >
                {{ ageBasedURL.displayText }}
              </a>
              and begin enrolling in classes.
            </p>
            <p class="d-none d-lg-flex step-content">
              <span class="stepFont">Step three</span>
              Once the above steps are completed, sign into your student dashboard at
              <a
                style="color: #ffc627"
                :href="ageBasedURL.href"
                target="_blank"
                @click="asuoDataLayerClick('Orientation', '1')"
              >
                {{ ageBasedURL.displayText }}
              </a>
              and begin enrolling in classes.
            </p>
          </div>
          <div class="orientationImage" style="margin-top: 31px">
            <v-icon class="orientation-icon-position2 orientation-icon-position3" id="fourth-icon">mdi-medal</v-icon>
            <p class="d-none d-md-flex" style="margin-left: 160px">
              <span class="stepFont">Step four</span>
              Congratulations, and welcome to {{ welcomePageTitle }}
            </p>
            <p class="d-none d-lg-flex step-content" style="margin-bottom: 50px">
              <span class="stepFont">Step four</span>
              Congratulations, and welcome to {{ welcomePageTitle }}
            </p>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="orientationFont" v-else style="margin: 1rem 0; height: 14rem">
      <v-row align-center justify="center" wrap>
        <v-col cols="10" lg="11" md="10" sm="10">
          <div style="text-align: center">{{ successMessage }}</div>
        </v-col>
        <div style="text-align: center">
          <!-- <v-btn @click="next" rounded style="margin-top:10px" v-if="isLoggedIn">
            Dashboard
            <v-icon v-if="loggedIn">mdi-arrow-right</v-icon>
          </v-btn>-->
          <div class="login-button" v-if="isLoggedIn">
            <v-btn @click="next" rounded color="#fec627" style="margin-top: 20px">
              Dashboard
              <v-icon v-if="loggedIn" style="padding-left: 8px">mdi-arrow-right</v-icon>
            </v-btn>
          </div>
          <div class="login-button" v-else>
            <v-btn @click="login()" rounded color="#fec627" style="margin-top: 20px">Log In</v-btn>
          </div>
        </div>
      </v-row>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';
import { useAuthStore } from '@/stores/auth';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { Logger } from '../mixins/logger';
import { Helper } from '../mixins/helpers';

export default defineComponent({
  name: 'OrientationComponent',
  data() {
    return {
      steps: {
        link: [],
        partnerName: ''
      },
      shouldLogin: false,
      successMessage: '',
      isLoggedIn: '',
      loggedIn: false
    };
  },

  mixins: [Helper, DataLayerMixin, Logger, AjaxLoader],

  props: {
    step: {
      type: Number
    }
  },

  methods: {
    login() {
      this.logInfo('calling auth0');

      this.$auth.login('asurite');
    },
    next() {
      if (this.loggedIn) {
        const authStore = useAuthStore();
        authStore.setPerformSignup(false);

        this.$router.push({ name: 'dashboard' });
      } else {
        this.$auth.login('asurite');
      }
    }
  },

  computed: {
    welcomePageTitle() {
      const userStore = useUserStore();
      return userStore.welcomePageData.studentPortalTitle;
    },
    ulcPartnerFlag() {
      return Helper.methods.isUlcPartner();
    },
    ageBasedURL() {
      if (this.ageBelow18) {
        return {
          href: 'https://welcome.ulc.asu.edu/',
          displayText: 'welcome.ulc.asu.edu'
        };
      }
      if (this.ulcPartnerFlag) {
        return {
          href: 'https://welcome.ulc.asu.edu/',
          displayText: 'welcome.ulc.asu.edu'
        };
      }
      return {
        href: 'https://welcome.ea.asu.edu/',
        displayText: 'welcome.ea.asu.edu'
      };
    }
  },

  created() {
    this.loggedIn = this.$auth.isAuthenticated();
    this.link = [this.ulcPartnerFlag ? 'https://welcome.ulc.asu.edu' : 'https://welcome.ea.asu.edu', 'welcome'];

    this.successMessage = this.loggedIn
      ? 'Please visit your dashboard to begin enrolling in courses.'
      : 'Log in with your ASURITE User ID to get started now.';
    this.isLoggedIn = this.loggedIn ? true : false;

    if (!this.$conn.learnerData) return this.$router.push({ name: 'login' });

    const authStore = useAuthStore();
    this.shouldLogin =
      authStore.performSignup || !!this.$conn.learnerData._asuRite || this.$conn.getPartnerName() === 'starbucks';

    this.birthday = this.$conn.learnerData._birthDate;
    this.ageBelow18 = this.birthday ? Helper.methods.calculateAge(this.birthday) / 365.25 < 18 : false;

    this.steps.partnerName = this.$conn.getPartnerName();
    this.steps.link[0] = this.steps.link[0].replace(/welcome/g, this.steps.partnerName);
    this.steps.link[1] = this.steps.link[1].replace(/welcome/g, this.steps.partnerName);
  }
});
</script>
